import React from "react";
import { processEmailNotifications, separatedByCommaCount, valdiatePage, validateEmail } from "../../global";
import { setLoading } from "../../redux/appSlice";
import { getSubAaccountsEmailNotifications, UpdateEmailNotification, getSubAccountLocations } from "../../services/userservice";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import UserModal from '../../components/userModal';

const EmailNotificationsUpdate = ({
    setViewType, emailData, updateEmailData, data, setEmailNotificationPayload, dispatch, emailNotificationType, userInfo, setData, subAccWithLoc, setSubAccWithLoc
}) => {
    const history = useHistory();

    const currentSA = {
        id: 0,
        name: ''
    };

    const [toEmailValidEntry, setToEmailValidEntry] = useState(true)
    const [toEmailTotalEntries, setToEmailTotalEntries] = useState(0)
    const [ccEmailValidEntry, setCcEmailValidEntry] = useState(true)
    const [ccEmailTotalEntries, setCcEmailTotalEntries] = useState(0)
    const [subaccounts, setSubaccounts] = useState([]);
    const [selectedReportType, setSelectedReportType] = useState([]);
    const [locations, setLocations] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [currentSubAccount, setCurrentSubAccount] = useState(currentSA);
    const [modalTypeEdit, setModalTypeEdit] = useState(false);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        const toEmailCount = separatedByCommaCount(emailData.ToEmail);
        setToEmailTotalEntries(toEmailCount)

        const ccEmailCount = separatedByCommaCount(emailData.CcEmail);
        setCcEmailTotalEntries(ccEmailCount)

        setSelectedReportType(emailData.emailType)
    }, [])

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (valdiatePage('/customerinfo')) {
            dispatch(setLoading({ data: true }));
            const rs = await getSubAaccountsEmailNotifications(userInfo);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setSubaccounts(rs.data);
            }
        } else {
            history.push('/login');
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    const toFindDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) !== index);

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onUpdateEmail = async () => {

        if (!toEmailValidEntry) {
            alert('To Email: Maximum 5 Email Allowed, Each Email separated by a comma.');
            return;
        }

        if (!ccEmailValidEntry) {
            alert('CC Email: Maximum 5 Email Allowed, Each Email separated by a comma.');
            return;
        }

        if (!emailData.ToEmail || emailData.ToEmail.trim() == '') {
            alert('Enter TO Email');
            return;
        }

        const multiToEmail = emailData.ToEmail.split(',');
        for (let i = 0; i < multiToEmail.length; i++) {
            if (validateEmail(multiToEmail[i].trim())) {
                alert(`To Email is invalid "${multiToEmail[i]}" on number ${[i + 1]}`);
                return false;
            }
        }

        if (toFindDuplicates(multiToEmail).length > 0) {
            alert(`To Email: Found dupicate Email "${toFindDuplicates(multiToEmail.map(e => e.toUpperCase())).join(", ")}"`);
            return false;
        }

        const multiCcEmail = emailData.CcEmail.split(',').filter(e => e !== "");
        if (multiCcEmail.length > 0) {
            for (let i = 0; i < multiCcEmail.length; i++) {
                if (validateEmail(multiCcEmail[i].trim())) {
                    alert(`CC Email is invalid "${multiCcEmail[i]}" on number ${[i + 1]}`);
                    return false;
                }
            }
        }

        if (toFindDuplicates(multiCcEmail).length > 0) {
            alert(`To Email: Found dupicate Email "${toFindDuplicates(multiCcEmail.map(e => e.toUpperCase())).join(", ")}"`);
            return false;
        }

        dispatch(setLoading({ data: true }));
        let payload = {
            "id": emailData.id,
            "toEmail": emailData.ToEmail,
            "toCc": emailData.CcEmail,
            "emailType": emailData.emailType,
            "subaccounts":
                subAccWithLoc.map(e => ({
                    "subaccountId": e.subAccount.id,
                    "locationId": e.locations
                }))

        }
        const rs = await UpdateEmailNotification(payload);
        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            alert("Email Updated Successfully")
            setEmailNotificationPayload(prev => { return { ...prev, notifications: [] } })
            updateEmailData("ToEmail", "")
            updateEmailData("CcEmail", "")
            updateEmailData("emailType", "")
            updateEmailData("emailTypeId", "")
            updateEmailData("id", 0)
            setViewType('list')
        } else {
            alert(rs.msg)
        }
    }

    const onToEmailChange = (e) => {
        const cnLengthValidated = separatedByCommaCount(e.target.value);
        setToEmailTotalEntries(cnLengthValidated)
        updateEmailData("ToEmail", e.target.value)
        if (cnLengthValidated > 5)
            setToEmailValidEntry(false)
        else
            setToEmailValidEntry(true)
    }

    const onCcEmailChange = (e) => {
        const cnLengthValidated = separatedByCommaCount(e.target.value);
        setCcEmailTotalEntries(cnLengthValidated)
        updateEmailData("CcEmail", e.target.value)
        if (cnLengthValidated > 5)
            setCcEmailValidEntry(false)
        else
            setCcEmailValidEntry(true)
    }

    const selectAllLocations = (isChecked) => {

        if (isChecked.target.checked) {
            let sublocs = [];
            subaccounts.forEach(async (e, i) => {
                const locs = await getSubAccountLocations(userInfo, e.id);
                sublocs.push(
                    {
                        "subAccount": {
                            "id": e.id,
                            "name": e.info.shipperName
                        },
                        "locations": locs.map(e => e.value)
                    }
                )
            })
            updateData("subAccounts", subaccounts.map(e => e.id))
            setSubAccWithLoc(sublocs)
        } else {
            updateData("subAccounts", [])
            setSubAccWithLoc([])
        }
        setSelectAll(isChecked.target.checked)
    }

    const getSubAccountsLocations = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setShowModal(true);
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name: name });
            updateData('locations', []);
        } else {
            alert(`Location not found against sub account ${name}`);
            setLocations([]);
            setCurrentSubAccount(currentSA)
        }
    }

    const onSecondClick = () => {
        if (modalTypeEdit) {
            if (data.locations.length > 0) {
                setSubAccWithLoc(subAccWithLoc.map((item) => {
                    return item.subAccount.id == Number(currentSubAccount.id) ? {
                        subAccount: currentSubAccount,
                        locations: data.locations
                    } : item
                }))
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        } else {
            if (data.locations.length > 0) {
                const updatedPages = [...data.subAccounts, Number(currentSubAccount.id)]
                updateData('subAccounts', updatedPages);
                setSubAccWithLoc(prev => [...prev, {
                    subAccount: currentSubAccount,
                    locations: data.locations
                }])
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        }
    }

    const removeSubAccount = (id) => {
        if (window.confirm('Are you sure?') == true) {
            setSubAccWithLoc(subAccWithLoc.filter((item) => { return Number(id) !== item.subAccount.id }))
            let updatedPages = [];
            updatedPages = data.subAccounts.filter((item) => { return Number(id) !== item })
            updateData('subAccounts', updatedPages);
        }
    }

    const editSubAccountLocation = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name })
            setModalTypeEdit(true)
            const findSALocation = subAccWithLoc.find((item) => { return Number(id) === item.subAccount.id })
            updateData('locations', findSALocation.locations);
            setShowModal(true)
        }
    }

    const reset = () => {
        updateData('locations', []);
    }

    return (
        <>
            {showModal && <UserModal onSecondClick={onSecondClick} response={locations} setShowModal={setShowModal} reset={reset} data={data} updateData={updateData} subAccount={currentSubAccount} />}

            <div className="section-header">
                <h1>Update Email Type</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => {
                    setViewType('list')
                }}>Back</button></div>

                <div className="row mt-2">
                    <label className={!toEmailValidEntry ? 'text-danger' : undefined}>
                        To Email: Total Email Count: ({toEmailTotalEntries}) {" "}
                        {!toEmailValidEntry && <label className='text-danger'>
                            Maximum 5 Email Allowed, Each Email separated by a comma.
                        </label>}
                    </label>
                </div>

                <div className="row mt-2">
                    <label className={!ccEmailValidEntry ? 'text-danger' : undefined}>
                        CC Email: Total Email Count: ({ccEmailTotalEntries}) {" "}
                        {!ccEmailValidEntry && <label className='text-danger'>
                            Maximum 5 Email Allowed, Each Email separated by a comma.
                        </label>}
                    </label>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <label>TO</label>
                        <input type="text" placeholder="Email" className="form-control" maxLength={250} value={emailData.ToEmail} onInput={processEmailNotifications} onChange={onToEmailChange} />
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <label>CC</label>
                        <input type="text" placeholder="Email" className="form-control"  maxLength={250} value={emailData.CcEmail} onInput={processEmailNotifications} onChange={onCcEmailChange} />
                    </div>
                </div>

                <div className="row mt-4 section-border">
                    <label>Report Type</label>
                    {
                        emailNotificationType.map((e, i) => <div key={i} className="col-lg-3 col-sm-12">
                            <label className="small-switch">
                                <input type="checkbox" name={e.reportName} value={e.id} checked={emailData.emailType.includes(Number(e.id))} onChange={c => {
                                    if (c.target.checked) {
                                        const reportType = [...selectedReportType, Number(e.id)]
                                        updateEmailData("emailType", reportType)
                                        setSelectedReportType(reportType);
                                    } else {
                                        const removeReportType = selectedReportType.filter(i => i !== Number(e.id))
                                        updateEmailData("emailType", removeReportType)
                                        setSelectedReportType(removeReportType);
                                    }
                                }} />
                                <span className="small-slider round"></span>
                            </label>
                            <label className="small-content-check">{e.reportName}</label>
                        </div>)
                    }
                </div>


                <div className="row mt-4 section-border">
                    <h3 style={{ margin: '10px' }}>Add Sub Accounts</h3>

                    <div className="card">
                        {
                            subaccounts && subaccounts.length > 0 &&
                            <>
                                <table className='table table-md table-bordered'>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Sub Account</th>
                                            <th>
                                                <div className="select-all-check">
                                                    <label className="small-switch">
                                                        <input type="checkbox" checked={selectAll} onChange={selectAllLocations} />
                                                        <span className="small-slider round"></span>
                                                    </label>
                                                    <label className="select-all-check-label">Select All</label>
                                                </div>
                                            </th>
                                            <th style={{ width: "15%" }}>Edit</th>
                                            <th style={{ width: "15%" }}>Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            subaccounts.map((e, index) =>
                                                <tr key={index}>
                                                    <td>{e.id}</td>
                                                    <td>
                                                        <div key={index}>
                                                            <label className="small-switch">
                                                                <input type="checkbox" name={e.info.shipperName} value={e.id} checked={data.subAccounts.includes(Number(e.id))} onChange={c => {
                                                                    if (c.target.checked) {
                                                                        getSubAccountsLocations(e.id, e.info.shipperName)
                                                                    }
                                                                }} />
                                                                <span className="small-slider round"></span>
                                                            </label>
                                                            <label className="small-content-check">{e.info.shipperName}</label>
                                                        </div>
                                                    </td>
                                                    <td></td>
                                                    {
                                                        data.subAccounts.includes(Number(e.id)) &&
                                                        <>
                                                            <td>
                                                                <div><button type='button' className='btn btn-sm btn-primary' onClick={() => editSubAccountLocation(e.id, e.info.shipperName)}>Edit</button></div>
                                                            </td>
                                                            <td>
                                                                <div><button type='button' className='btn btn-sm btn-primary' onClick={() => removeSubAccount(e.id)}>Remove</button></div>
                                                            </td>
                                                        </>
                                                    }
                                                </tr>)
                                        }
                                    </tbody>
                                </table>
                            </>
                        }
                    </div>            
                </div>

                <div className="col-lg col-sm-12 mt-3" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" onClick={onUpdateEmail}>Update</button>
                </div>
            </div></>
    )

}

export default EmailNotificationsUpdate;